import { useEffect, useRef } from "react"
import useSfx from "../../utils/useSfx"
import { useInterestPointStore } from "../../store/uneInterestPointsStore"


export default function InterestPoints() {
    const { soundRef, loadedRef, targetVolume } = useSfx("/audio/sfx/circle.mp3", false)

    const activeInterestPointId = useInterestPointStore(
        (s) => (s.activeInterestPointId !== null ? s.activeInterestPointId : null)
    )

    const lastIdRef = useRef(null)

    useEffect(() => {
        let timeoutId
        if (activeInterestPointId == null) {
            lastIdRef.current = null
            return
        }
        if (lastIdRef.current === activeInterestPointId) return
        lastIdRef.current = activeInterestPointId

        const delayMs = 200
        timeoutId = setTimeout(() => {
            targetVolume.current = 0.6
            soundRef.current?.play(0)
        }, delayMs)

        return () => {
            if (timeoutId) clearTimeout(timeoutId)
        }

    }, [activeInterestPointId, loadedRef, soundRef])

    return null
}
